import { render, staticRenderFns } from "./MPggTable.vue?vue&type=template&id=7458f5c8&scoped=true"
import script from "./MPggTable.vue?vue&type=script&lang=js"
export * from "./MPggTable.vue?vue&type=script&lang=js"
import style0 from "./MPggTable.vue?vue&type=style&index=0&id=7458f5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458f5c8",
  null
  
)

export default component.exports